import { render, staticRenderFns } from "./GatewayDocumentView.html?vue&type=template&id=6ea017e8&scoped=true&external"
import script from "./GatewayDocumentView.js?vue&type=script&lang=js&external"
export * from "./GatewayDocumentView.js?vue&type=script&lang=js&external"
import style0 from "./GatewayDocumentView.scss?vue&type=style&index=0&id=6ea017e8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea017e8",
  null
  
)

export default component.exports